<ispui-select
  [id]="id"
  [required]="required"
  [multiple]="multiple"
  [disabled]="disabled"
  [options]="internalOptions"
  [builderParams]="selectBuilderParams"
  [ngModel]="value"
  (ngModelChange)="onModelChange($event)"
  (internalAction)="checkDropdownOpen($event)"
  (keyup.enter)="keyupEnter($event)"
  #select
></ispui-select>
